export const getHostname = () => window.location.host?.replace(/:[0-9]+/, '');
